import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudioAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_audio_attachment)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 4.8C0 2.14903 2.14903 0 4.8 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L23.2971 5.29706C23.7471 5.74714 24 6.35759 24 6.99411V19.2C24 21.851 21.851 24 19.2 24H4.8C2.14903 24 0 21.851 0 19.2V4.8ZM6.6 13C6.6 12.5582 6.95817 12.2 7.4 12.2C7.84183 12.2 8.2 12.5582 8.2 13V16.6C8.2 17.0418 7.84183 17.4 7.4 17.4C6.95817 17.4 6.6 17.0418 6.6 16.6V13ZM10.4 10.2C9.95817 10.2 9.6 10.5582 9.6 11V18.6C9.6 19.0418 9.95817 19.4 10.4 19.4C10.8418 19.4 11.2 19.0418 11.2 18.6V11C11.2 10.5582 10.8418 10.2 10.4 10.2ZM12.6 12.4C12.6 11.9582 12.9582 11.6 13.4 11.6C13.8418 11.6 14.2 11.9582 14.2 12.4V17.2C14.2 17.6418 13.8418 18 13.4 18C12.9582 18 12.6 17.6418 12.6 17.2V12.4ZM16.4 9.4C15.9582 9.4 15.6 9.75817 15.6 10.2V19.4C15.6 19.8418 15.9582 20.2 16.4 20.2C16.8418 20.2 17.2 19.8418 17.2 19.4V10.2C17.2 9.75817 16.8418 9.4 16.4 9.4ZM18.6 13.6C18.6 13.1582 18.9582 12.8 19.4 12.8C19.8418 12.8 20.2 13.1582 20.2 13.6V16C20.2 16.4418 19.8418 16.8 19.4 16.8C18.9582 16.8 18.6 16.4418 18.6 16V13.6Z",
			fill: "#4F49BA"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_audio_attachment",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAudioAttachment;
